import { Injectable } from '@angular/core';
import { Relationship } from '../model/relationship.model';
import { RestService } from '../../../services/rest.service';
import { PaginatedResponse } from '../../../interface/PaginatedResponse';

@Injectable({
    providedIn: 'root'
})
export class RelationshipService {

    static ApiEndpoint = 'relationships/'

    constructor(private restService: RestService) { }


    async readAllCustomers(page: number = 1, search: string = '') {
        return (await this.restService.send<PaginatedResponse<Relationship>>({
            url: RelationshipService.ApiEndpoint + 'customers',
            method: 'GET',
            query: {
                page: page,
                searchName: search
            }
        }))
    }

    async readCustomerById(id: string) {
        return (await this.restService.send<Relationship>({
            url: RelationshipService.ApiEndpoint + id,
            method: 'GET'
        }))
    }

} 